module.exports = __webpack_public_path__ + "static/media/cloud_academy_logo.65d42e12.png";